module.exports = __webpack_public_path__ + "static/scale-model-of-sunken-gardens-in-lincoln-nebraska-01f83d665938473a8e23dc68475f80a4.png";